import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import {
	Container,
	ContentWrapper,
	Image,
	ImageWrapper,
	Wrapper
} from './block-image.styles';

const BlockImage = ({
	banner,
}) => {

	return (
		<Container>
			<Wrapper>
				{banner && <ContentWrapper>
					<ImageWrapper>
						<Image as={GatsbyImage} alt={banner.alt || ""} image={banner.gatsbyImageData} objectFit="cover" objectPosition="50% 50%" />
					</ImageWrapper>
				</ContentWrapper>}
				<ContentWrapper>
				</ContentWrapper>
			</Wrapper>
		</Container>
	);
};

export default BlockImage;
